import { render, staticRenderFns } from "./SingleShareLinkButton.vue?vue&type=template&id=2b3e2caf&scoped=true&"
import script from "./SingleShareLinkButton.vue?vue&type=script&lang=js&"
export * from "./SingleShareLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./SingleShareLinkButton.vue?vue&type=style&index=0&id=2b3e2caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e2caf",
  null
  
)

export default component.exports